import { render, staticRenderFns } from "./ChatHistory.vue?vue&type=template&id=1fa59be7"
import script from "./ChatHistory.vue?vue&type=script&lang=js"
export * from "./ChatHistory.vue?vue&type=script&lang=js"
import style0 from "./ChatHistory.vue?vue&type=style&index=0&id=1fa59be7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../Users/a0000/Documents/Box-IM/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports